module.exports = __webpack_public_path__ + "img/003.fa4fc5b0.png";